import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ROOT_URL } from "../../api/ApiConfig";

export const getPublicArticleById = createAsyncThunk(
  "publicArticleDetail/getPublicArticleById",
  async ({ articleId, group_id }, { rejectWithValue }) => {
    try {
      if (!articleId) {
        throw new Error("Article ID is required");
      }

      const url = `${ROOT_URL}/kb/article-ex/${articleId}`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
        params: group_id ? { group_id } : undefined,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  article: null,
  lastFetchedArticleId: null,
  cacheByArticleId: {},
};

const getPublicArticleByIdSlice = createSlice({
  name: "getPublicArticleById",
  initialState,
  reducers: {
    resetPublicArticleDetail: (state) => {
      state.article = null;
      state.loading = false;
      state.error = null;
      state.lastFetchedArticleId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPublicArticleById.pending, (state, action) => {
        const idStr =
          action.meta.arg?.articleId != null
            ? String(action.meta.arg.articleId)
            : "";
        const cached = idStr && state.cacheByArticleId[idStr];
        const inMemorySame =
          idStr &&
          state.lastFetchedArticleId != null &&
          String(state.lastFetchedArticleId) === idStr &&
          state.article != null;
        if (cached) {
          state.article = cached;
          state.loading = false;
        } else if (inMemorySame) {
          state.loading = false;
        } else {
          state.loading = true;
          const currentId =
            state.article?._id != null ? String(state.article._id) : "";
          if (idStr && currentId && currentId !== idStr) {
            state.article = null;
          }
        }
        state.error = null;
      })
      .addCase(getPublicArticleById.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload?.data || null;
        state.article = data;
        const requestedId =
          action.meta.arg?.articleId != null
            ? String(action.meta.arg.articleId)
            : "";
        if (requestedId && data) {
          state.cacheByArticleId[requestedId] = data;
          state.lastFetchedArticleId = requestedId;
        }
      })
      .addCase(getPublicArticleById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPublicArticleDetail } = getPublicArticleByIdSlice.actions;
export default getPublicArticleByIdSlice.reducer;
